// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCourses-cls1_z4C","cls2":"NewCourses-cls2_YDc NewCourses-cls1_z4C"};